import { useFormikContext } from 'formik';

import Button from 'components/shared/Button/Button';
import ColorPicker from 'components/shared/ColorPicker/ColorPicker';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import SectionList from 'components/practice/UserPreferences/components/SectionList';

const DEFAULT_PRIMARY_COLOR = '#0BA5EC';
const DEFAULT_SECONDARY_COLOR = '#0BA5EC';

const PracticeBranding = () => {
  const { values, setFieldValue } = useFormikContext();
  const branding = values?.displaySettings?.branding || {};
  const primaryColor = branding.primary_color || DEFAULT_PRIMARY_COLOR;
  const secondaryColor = branding.secondary_color || DEFAULT_SECONDARY_COLOR;

  const setBranding = (patch) =>
    setFieldValue('displaySettings', {
      ...values.displaySettings,
      branding: { primary_color: primaryColor, secondary_color: secondaryColor, ...patch }
    });

  const resetToDefault = () => {
    const { branding: _branding, ...rest } = values.displaySettings || {};
    setFieldValue('displaySettings', rest);
  };

  return (
    <SectionList
      title="Patient-facing branding"
      description="These colors style the screens your patients see — self-scheduling, check-in, instant packets, and the kiosk — and the emails they receive, such as appointment reminders, receipts, and invoices. Your practice logo appears in those emails too. Your practice portal keeps its Myriad look and won't change.">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap gap-8">
          <ColorPicker
            label="Primary color"
            color={primaryColor}
            onChange={(color) => setBranding({ primary_color: color })}
          />
          <ColorPicker
            label="Secondary color"
            color={secondaryColor}
            onChange={(color) => setBranding({ secondary_color: color })}
          />
        </div>
        <div>
          <Button
            text="Reset to Myriad default"
            variant="link"
            size="small"
            onClick={resetToDefault}
          />
        </div>
      </div>
    </SectionList>
  );
};

export default withErrorBoundary(PracticeBranding);
